module.exports = __webpack_public_path__ + "img/29.0efbac6f.png";